import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'
import classes from '../List.scss'

export const ListColumn = (props) => {
  const options = Array.isArray(props.options) && props.options || [props.options] // always wrap options in an array
  const hasOption = (option) => options.indexOf(option) > -1

  // options => class styling
  const classList = { [classes['column']]: true }

  // add all options into the classList
  options.forEach((option) => {
    classList[classes[`column--${option}`]] = classes[`column--${option}`]
  })

  // list of options only when not a header (overrides all setting)
  ;['bold', 'italic', 'unimportant', 'success', 'error'].forEach(option => {
    classList[classes[`column--${option}`]] = classes[`column--${option}`] &&
      hasOption('option') && !hasOption('header')
  })

  let rowProps = { className: cx(classList) }
  if (props.colspan > 1) rowProps.colSpan = props.colspan

  return React.createElement(
    hasOption('header') ? 'th' : 'td', // purely semantic
    rowProps,
    props.children
  )
}

ListColumn.propTypes = {
  children: PropTypes.node,
  options: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string
  ]),
  colspan: PropTypes.number
}

ListColumn.defaultProps = {
  options: []
}

export default ListColumn



// WEBPACK FOOTER //
// ./src/components/BetterList/Column/ListColumn.js